/**
 * Ref: https://emailregex.com/
 */
export const email = {
	regex: new RegExp(
		/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	),
	pattern: undefined, // use <input type="email"...>
};

export const link = {
	regex: new RegExp(
		/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
	),
	pattern: undefined, // use <input type="url"...>
};

export const ethereumAddress = {
	regex: new RegExp(/^0x[a-fA-F0-9]{40}$/),
	pattern: '^(0x){1}[0-9a-fA-F]{40}$',
};

export const hex = {
	regex: new RegExp(/0[xX][0-9a-fA-F]+/),
	pattern: '0[xX][0-9a-fA-F]+',
};
